import { Link, Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { brandName, publicAsset } from "./careData";
import { Logo } from "../../components/care/CareLayout";

function PublicNav() {
  return (
    <header className="topbar public-topbar">
      <Logo />
      <nav className="public-nav" aria-label="Main navigation">
        <a href="#find-care">Find Care</a>
        <a href="#work">Find Care Work</a>
        <a href="#hire">Hire Care Professionals</a>
        <Link to="/dashboard">Manage Care</Link>
        <a href="#pricing">Pricing</a>
      </nav>
      <div className="topbar-actions">
        <Link className="ghost-link" to="/login">Sign In</Link>
        <Link className="btn primary" to="/home">Get Started</Link>
      </div>
    </header>
  );
}

function Footer() {
  return (
    <footer className="site-footer">
      <div>
        <Logo />
        <p>Care planning, trusted professionals, and better coordination, all in one place.</p>
        <small>© 2026 Olreadia Care. All rights reserved.</small>
      </div>
      <div><strong>Platform</strong><a href="#find-care">Find Care</a><a href="#work">Find Care Work</a><a href="#manage">Manage Care</a><a href="#pricing">Pricing</a></div>
      <div><strong>Resources</strong><a href="#help">Help Center</a><a href="#privacy">Privacy Policy</a><a href="#terms">Terms of Service</a></div>
      <div><strong>Follow Us</strong><div className="socials"><span><i className="ti ti-brand-facebook" /></span><span><i className="ti ti-brand-linkedin" /></span><span><i className="ti ti-brand-instagram" /></span></div></div>
    </footer>
  );
}

export default function LandingPage() {
  const { isAuthenticated, loading } = useAuth();

  if (!loading && isAuthenticated) {
    return <Navigate to="/home" replace />;
  }

  const cards = [
    ["ti-user-heart", "Find Care", "Find the right care and support for yourself or a loved one."],
    ["ti-briefcase", "Find Care Work", "Create a verified profile and discover care work that fits your skills and schedule."],
    ["ti-users-group", "Hire Care Professionals", "Find verified caregivers, nurses, and care staff for your organization or family."],
    ["ti-clipboard-check", "Manage Resident Care", "Streamline assessments, care plans, daily notes, and care-team coordination."],
  ];

  return (
    <div className="page public-page">
      <PublicNav />
      <main>
        <section className="hero">
          <div className="hero-copy">
            <h1>Care planning, trusted professionals, and better coordination, all in one place.</h1>
            <p>{brandName} helps families, care professionals, and care providers find care, hire trusted caregivers, and manage resident care with confidence.</p>
            <div className="button-row">
              <Link className="btn primary" to="/home">Get Started</Link>
              <Link className="btn secondary" to="/dashboard"><i className="ti ti-calendar" /> Book a Demo</Link>
            </div>
          </div>
          <div className="hero-media" aria-label="Caregiver supporting an older adult">
            <img className="hero-photo" src={publicAsset("/care/care.png")} alt="Caregiver supporting an older adult" />
            <div className="floating-note"><i className="ti ti-shield-check" /><span>Verified care teams for Reliable Care Planning</span></div>
          </div>
        </section>

        <section className="public-section" id="find-care">
          <h2>How can {brandName} help you today?</h2>
          <div className="landing-card-grid">
            {cards.map(([icon, title, text]) => (
              <Link className="landing-card" to={title === "Manage Resident Care" ? "/dashboard" : "/home"} key={title}>
                <span className="soft-icon"><i className={`ti ${icon}`} /></span>
                <div><h3>{title}</h3><p>{text}</p><i className="ti ti-arrow-right arrow" /></div>
              </Link>
            ))}
          </div>
          <div className="benefit-strip">
            <div><span><i className="ti ti-clipboard-check" /></span><strong>Simplify Care Planning</strong><p>Create personalized care plans and track progress in one place.</p></div>
            <div><span><i className="ti ti-shield-check" /></span><strong>Build Trust</strong><p>Verified professionals and transparent profiles you can count on.</p></div>
            <div><span><i className="ti ti-calendar-check" /></span><strong>Stay Organized</strong><p>Keep everything in sync with tools that save time and reduce stress.</p></div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
